import { PERMISSIONS } from '@globalConstants';
import { usePermissions } from '@hooks';
import { FormModal } from '@organisms';
import { CONFIG_AREA_FIELD, VALIDATION_AREA_SCHEMA } from './constants';

export interface AreaValues {
  areaName: string;
  costCenter: string | null;
}
interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  isLoading: boolean;
  onSubmit: (values: AreaValues) => void;
  initialValues?: AreaValues;
  isEditing?: boolean;
}

/**
 * Modal to create or edit areas
 * @param props
 * @param props.isOpen - Boolean to indicate if the modal is open
 * @param props.closeModal - Function to close the modal
 * @param props.isLoading- Boolean to indicate that the modal action is loading
 * @param props.onSubmit - Function to be called when the modal is submitted
 * @param props.isEditing - Boolean to indicate if the modal is for area edition instead of creation
 */
const AreaCreationModal = ({
  isOpen,
  closeModal,
  isLoading,
  onSubmit,
  initialValues = { areaName: '', costCenter: '' },
  isEditing,
}: ModalProps): JSX.Element => {
  const isDemo = usePermissions([PERMISSIONS.demoUpdateArea]);
  return (
    <FormModal
      title={isEditing ? 'CLIENTS:CREATE_AREA:EDIT_MODAL' : 'CLIENTS:CREATE_AREA:ADD'}
      isOpen={isOpen}
      validationSchema={VALIDATION_AREA_SCHEMA}
      configFields={CONFIG_AREA_FIELD}
      onClose={closeModal}
      initialValues={initialValues}
      showClearFilter={false}
      isLoading={isLoading}
      onSubmit={onSubmit}
      resetOnSubmit={!isEditing}
      disableConfirm={isDemo}
    />
  );
};

export default AreaCreationModal;
